import { LikedButton } from "./liked-button";
import { SaveButton } from "./save-button";
import { useSaveSingleColor } from "../../save-single-color";

export function SaveSingleColorWrapper() {
  const { isLoggedIn } = useSaveSingleColor();

  return (
    <>
      {!isLoggedIn && <LikedButton />}
      {isLoggedIn && <SaveButton />}
    </>
  );
}
